import React, { useEffect } from 'react';
import { LoadingPage, ErrorPage as CJErrorPage } from 'cj-common-react';
import { ERROR_PAGE_ENUMS } from '../config';
const { PASSWORD_EXPIRED, LAUNCH_DARKLY_INIT_FAILURE } = ERROR_PAGE_ENUMS;

const ErrorPage = ({ error }) => {
  console.error('[ErrorPage] error: ', error);
  useEffect(() => {
    if (
      error === 'password_expired' &&
      !window.location.href.includes('home') // to prevent redirect loop
    ) {
      const stage = process.env.REACT_APP_STAGE || 'dev'; // defaulting to DEV since there is no password expiration page for local
      const redirectURL =
        stage === 'prod'
          ? 'https://home.carejourney.com/passwordexpiration.html?error=password_expired'
          : `https://home-${stage}.carejourney.com/passwordexpiration.html?error=password_expired`;
      window.location.href = redirectURL;
    }
  }, [error]);

  if (error === PASSWORD_EXPIRED) {
    return <LoadingPage />;
  }

  if (error === LAUNCH_DARKLY_INIT_FAILURE) {
    return <CJErrorPage />;
  }

  return (
    <div>
      <h1>Error!</h1>
      <p>{error}</p>
    </div>
  );
};

export default ErrorPage;
